<!--
 * @Description: 项目人员管理-独立模块
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render
    @select="handleSelect"
    @select-all="handleSelectAll"
    @changeChildActive="handleChildChange"
    @respondFinished="handleRespondFinished"
    ref="tableRender"
    :config="config"
    :key="tableKey"
    :row-class-name="_getUnqualifiedRowConfig"
  >
    <template slot="top-alert" slot-scope="scope">
      <!-- FIXME: 暂时使用。申请名单去掉多选并禁用审核：scope.childActiveIndex == 0 -->
      <div
        style="display: flex;margin-bottom: 20px;margin-top: 10px;align-items: center;"
        v-if="
          scope.activeIndex == 0 &&
            needCertification &&
            scope.childActiveIndex == 0
        "
      >
        <div style="display: flex;align-items: center;flex-shrink: 0;">
          <div>已选{{ selection.length }}项，批量操作</div>
          <div style="margin-left: 10px;">
            <el-button @click="batchPass" size="mini" type="primary">
              批量通过
            </el-button>
            <el-button @click="batchReturn" size="mini" type="info">
              批量驳回
            </el-button>
          </div>
        </div>
        <div style="color: red;margin-left: 12px;">{{ certificationText }}</div>
      </div>
    </template>
  </table-render>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { mapState } from 'vuex';
import sanji from '@/Mixin/sanji';
import { judge } from '@/Mixin/judge';
import { deepClone } from '@/tools';
import { certification } from '@/api/ajax';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
import {
  passQualifications,
  rejectQualifications
} from './components/qualification-detail';
export default {
  name: 'projectSettle',
  mixins: [sanji, judge],
  provide() {
    return {
      _parent: this // 把当前实例传递给后续弹层使用
    };
  },
  data() {
    return {
      tableKey: 1,
      needCertification: false, // true批量 false单条
      certificationText: '',
      config: null,
      searchQuery: {},
      selection: []
    };
  },
  ...mapState({
    projectType: state => state.homeProject.projectType,
    projectId: state => state.homeProject.projectId,
    homeProject: state => state.homeProject
  }),
  components: { tableRender },
  methods: {
    _getUnqualifiedRowConfig({ row, rowIndex }) {
      let unqualifiedMsg = '';
      if (row.zbBlackStatus === 2) {
        unqualifiedMsg = '银行账户异常';
      }
      if (row.superviseStatus === 3) {
        unqualifiedMsg = '数据监测不合格，系统已自动拦截';
      }
      return getUnqualifiedRowConfig({
        row: {},
        rowIndex: rowIndex,
        unqualifiedMsg: unqualifiedMsg ? `【${unqualifiedMsg}】` : '',
        isNotUnqualified: !(
          row.zbBlackStatus === 2 || row.superviseStatus === 3
        )
      });
    },
    clearSelection() {
      const states = this.$refs['tableRender'].$refs['table'].store.states;
      states.isAllSelected = false;
      states.selection = [];
      this.selection = [];
    },
    handleRespondFinished() {
      this.clearSelection();
    },
    handleSelect(selected) {
      this.selection = selected;
    },
    handleSelectAll(selected) {
      this.selection = selected;
    },
    handleChildChange() {
      this.clearSelection();
    },
    audit(type) {
      if (this.selection.length == 0) {
        this.$message({
          type: 'info',
          message: '至少选择一条！'
        });
        throw new Error('less than one');
      }
      let _type = 1;
      try {
        _type = this.$refs['tableRender'].defaultQuery._qualificationAuditParams
          .type;
      } catch (error) {
        console.warn(
          'get defaultQuery _qualificationAuditParams type fail',
          error
        );
      }
      return { pass: passQualifications, reject: rejectQualifications }[type](
        this.selection.map(i => i.userId).filter(Boolean),
        {
          isNextData: 1,
          projectId: this.projectId,
          type: _type
        }
      );
    },
    async batchPass() {
      await this.audit('pass');
      this.$refs['tableRender'].reGetPage();
    },
    async batchReturn() {
      await this.audit('reject');
      this.$refs['tableRender'].reGetPage();
    }
  },
  async created() {
    try {
      const {
        data: { data }
      } = await certification.queryProjectExtendCertification({
        projectId: this.projectId
      });
      this.needCertification = data === 1;
    } catch (error) {
      console.warn('get certification status', error);
    }
    // FIXME: 暂时使用。申请名单去掉多选并禁用审核。applyHandler
    const removeFields = new Set(
      this.needCertification
        ? [
            // 'applyHandler',
            'checkStatus'
          ]
        : [
            'selection',
            'certificationUpload',
            'auditOssStatus',
            'importOperation'
          ]
    );
    const removeSearchs = new Set(
      this.needCertification
        ? ['checkStatus']
        : [
            'applyCertificationStatus',
            'certificationStatus',
            'certificationUpload'
          ]
    );

    const conf = deepClone(config);
    conf.forEach(item => {
      item.childMenu.forEach(item2 => {
        item2.defaultQuery = {
          ...(item2.defaultQuery || {}),
          projectId: this.projectId,
          projectType: this.projectType
        };

        // 是园区
        if (this.$store.getters.isPark) {
          item2.fields.forEach(field => {
            if (field.prop === 'userName') {
              field.label = '经营者';
            }
          });
          item2.search.forEach(field => {
            if (field.key === 'userName') {
              field.label = '经营者';
            }
          });
          return;
        }

        // 个体
        if (this.searchQuery.projectStructureType % 2 == 0) {
          item2.fields.forEach(field => {
            if (field.prop === 'userName') {
              field.label = '经营者';
            }
          });
          item2.search.forEach(field => {
            if (field.key === 'userName') {
              field.label = '经营者';
            }
          });
          return;
        }

        //个人
        item2.fields.forEach((field, index) => {
          if (field.prop === 'zooidEnterpriseName') {
            item2.fields.splice(index, 1);
          }
          if (field.prop === 'userName') {
            field.label = '项目参与人';
          }
        });
        item2.search.forEach((field, index) => {
          if (field.key === 'zooidEnterpriseName') {
            item2.search.splice(index, 1);
          }
          if (field.prop === 'userName') {
            field.label = '项目参与人';
          }
        });

        item2.fields = item2.fields.filter(
          field => !removeFields.has(field.prop)
        );
        item2.search = item2.search.filter(
          search => !removeSearchs.has(search.id)
        );
      });
    });

    this.config = conf;
    this.tableKey += 1;

    if (this.needCertification) {
      certification
        .queryCertificationList({ projectId: this.projectId })
        .then(({ data: { data } }) => {
          if (Array.isArray(data) && data.length > 0) {
            this.certificationText = `项目资质要求：${data
              .map(i => i.map(i => `【${i.certificationName}】`).join('或'))
              .join('，')}`;
          }
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
